Ext.define('SA.view.mapexport.overlay.LabelEditWindow', {
    alias: 'widget.export-label-edit-window',
    extend: 'SA.view.mapexport.overlay.AbstractEditWindow',

    cls: 'sa-label-edit-window',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-label-edit-window-section sa-label-edit-window-upper-section',

            items: [
                {
                    xtype: 'simple-container',
                    cls: 'sa-label-edit-window-label-row',

                    items: [
                        {
                            xtype: 'sa-textfield',
                            cls: 'sa-label-edit-window-label-field',
                            itemId: 'text',
                            maxLength: 60
                        }, {
                            xtype: 'remove-button',
                            cls: 'sa-label-edit-window-remove-btn',
                            itemId: 'deleteLabelButton',
                            tooltip: 'Delete this text label' 
                        }
                    ]
                }, {
                    xtype: 'combo-button',
                    cls: 'sa-label-edit-window-typeface-combo',
                    itemId: 'typefaceCombo',
                    menuCls: 'sa-menu-compact',

                    items: [
                        'Courier New',
                        'Verdana'
                    ]
                }, {
                    xtype: 'simple-container',
                    cls: 'sa-label-edit-window-styles-row',

                    items: [
                        {
                            xtype: 'combo-button',
                            cls: 'sa-label-edit-window-font-size-combo',
                            itemId: 'fontSizeCombo',
                            items: [12, 16, 20, 24, 28, 32, 36],
                            menuCls: 'sa-menu-compact'
                        }, {
                            xtype: 'color-chooser',
                            itemId: 'textColor',
                            value: '000000'
                        }, {
                            xtype: 'color-chooser',
                            allowTransparent: true,
                            itemId: 'backgroundColor',
                            value: 'ffffff'
                        }, {
                            xtype: 'sa-toggle-button',
                            cls: 'sa-label-edit-window-font-style-btn sa-label-edit-window-bold-btn',
                            itemId: 'bold',
                            text: 'B'
                        }, {
                            xtype: 'sa-toggle-button',
                            cls: 'sa-label-edit-window-font-style-btn sa-label-edit-window-italic-btn',
                            itemId: 'italic',
                            text: 'I'
                        }, {
                            xtype: 'sa-toggle-button',
                            cls: 'sa-label-edit-window-font-style-btn sa-label-edit-window-underline-btn',
                            hidden: true,
                            itemId: 'underline',
                            text: 'U'
                        }
                    ]
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-label-edit-window-section sa-label-edit-window-lower-section',

            items: [
                {
                    xtype: 'export-units-field',
                    allowDecimals: false,
                    cls: 'sa-label-edit-window-units-field',
                    fieldLabel: 'Left',
                    itemId: 'left',
                    labelWidth: 43,
                    width: 178
                }, {
                    xtype: 'export-units-field',
                    allowDecimals: false,
                    cls: 'sa-label-edit-window-units-field',
                    fieldLabel: 'Top',
                    itemId: 'top',
                    labelWidth: 43,
                    width: 178
                }
            ]
        }
    ],

    initComponent() {
        this.callParent();

        this.textField = this.down('#text');

        this.typefaceCombo = this.down('#typefaceCombo');
        this.fontSizeCombo = this.down('#fontSizeCombo');

        this.textColor = this.down('#textColor');
        this.backgroundColor = this.down('#backgroundColor');

        this.boldButton = this.down('#bold');
        this.italicButton = this.down('#italic');
        this.underlineButton = this.down('#underline');

        this.leftField = this.down('#left');
        this.topField = this.down('#top');
    },

    refresh() {
        var record = this.record,
            dimensions = this.dimensions;

        this.textField.setValue(record.getText());
        this.typefaceCombo.setValue(record.getTypeface());
        this.fontSizeCombo.setValue(record.getSize());
        this.textColor.setValue(record.getColor());
        this.backgroundColor.setValue(record.getBackground());
        this.boldButton.setPressed(record.isBold());
        this.italicButton.setPressed(record.isItalic());
        this.underlineButton.setPressed(record.isUnderline());

        this.leftField.setValue(dimensions.left);
        this.topField.setValue(dimensions.top);
    }
});
